
import { Box } from "@mui/material";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, TablaProveedores } from "../../components";
import { useProveedoresQuery } from "../../../hooks";




export const ListadoProveedor = () => {


    const { proveedoresListQuery, termino, chageTermino, chagePage, page } = useProveedoresQuery();


    return (

        <DisenioPaginas titulo="Listado de Proveedores" url="add/new/proveedor">
            {(proveedoresListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando unidades de medida..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar proveedor...' place='Buscar x nombre...'/>
                <TablaProveedores data={proveedoresListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }
            <Box sx={{height:30}} />
        </DisenioPaginas>

    )
}
